<template>
  <div class="wrap writeinvoice-wrap flex-column">
    <mu-infinite-scroll :loading="load" loadingText="拼命加载中" class="load" v-if="load"/>
    <div class="flex-item" v-if="!load">
      <div class="invoice-box">
        <p class="title">
          发票类型：
        </p>
        <div class="content">
          <div class="invoice-type-box">
            <mu-chip class="demo-chip" v-bind:class="[ invoiceData.invoiceType == typeItem.value? 'primary' : '']" v-for="typeItem in invoiceTypeList" :key="typeItem.value" @click="invoiceData.invoiceType = typeItem.value;invoiceData.invoiceTypeName = typeItem.name">{{typeItem.name}}</mu-chip>
          </div>
        </div>
      </div>
      <div class="invoice-box">
        <p class="title">
          发票抬头：
        </p>
        <div class="content">
          <div class="invoice-title-box">
            <div class="radio-box">
              <mu-radio nativeValue="person" v-model="invoiceTitle" class="list-radio" label="个人" v-bind:class="['person'==invoiceTitle? 'primary' : '']" @change="invoiceData.invoiceHead = '个人';invoiceData.uniformCode = ''" />
              <mu-radio nativeValue="company" v-model="invoiceTitle" class="list-radio" label="单位" v-bind:class="['company'==invoiceTitle? 'primary' : '']" />
            </div>
            <!-- 单位列表 -->
            <div class="company-list" v-show="invoiceTitle=='company' && memInvoiceMsgList.length > 0">
              <div class="company-item" v-for="(item,index) in memInvoiceMsgList">
                <p class="ellipsis floatL" @click="selcompanycheckbox(index)">{{item.invoiceHead}}</p>
                <p class="edit-company fr" v-show="isEditState">
                  <label class="primary" @click="write('modify',index)">编辑</label>
                  <label class="primary" @click="write('delete',index)">删除</label>
                </p>
                <mu-radio :nativeValue="item.invoiceHead" v-model="selectedCompanyid" class="list-radio fr" v-bind:class="[item.invoiceHead==invoiceData.invoiceHead? 'primary' : '']" v-show="!isEditState" @change="invoiceData.invoiceHead = item.invoiceHead;invoiceData.uniformCode = item.uniformCode" />
                <div class="clear"></div>
              </div>
            </div>
            <!-- 当 单位记录为空 & 选中的值为单位 || 新增状态-->
            <div class="write-company" v-show="(invoiceTitle == 'company'  && memInvoiceMsgList.length <= 0) || (isAddState)">
              <input type="text" placeholder="新增单位发票抬头" v-model="addInfo.invoiceHead">
              <input type="text" placeholder="请输入纳税人识别号" v-model="addInfo.uniformCode">
            </div>
            <!-- 操作按钮 单位时出现-->
            <div class="operate" v-show="invoiceTitle=='company'">
              <label class="blue" @click="write('edit',null)" v-show="memInvoiceMsgList.length > 0 && !isEditState && !isAddState">编辑单位</label>
              <label class="blue" @click="write('add',null)" v-show="memInvoiceMsgList.length > 0 && !isEditState && !isAddState">新增单位</label>
              <label class="blue" @click="write('finish',null)" v-show="isEditState && !isAddState">完成</label>
              <label class="blue" @click="write('quit',null)" v-show="isAddState && !isEditState">取消</label>
              <label class="blue" @click="write('save',null)" v-show="(invoiceTitle == 'company' && memInvoiceMsgList.length <= 0 ||isAddState) && !isEditState">保存</label>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <div class="invoice-box">
        <p class="title">
          发票内容：
        </p>
        <div class="content">
          <div class="invoice-content-box">
            <div class="radio-box">
              <mu-radio :nativeValue="item.name" v-model="invoiceData.invoiceContentName" class="list-radio" :label="item.name" v-for="item in invoiceContentList" v-bind:class="[item.value==invoiceData.invoiceContent? 'primary' : '']" @change="invoiceData.invoiceContent = item.value;invoiceData.invoiceContentName = item.name" :key="item.value" />
              <!-- <mu-radio  nativeValue="detail" v-model="invoiceContent" class="list-radio" label="明细" v-bind:class="['detail'==invoiceContent? 'primary' : '']" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn-box" v-if="!load">
      <div class="bottom-full-button">
        <mu-raised-button label="确 定" fullWidth primary @click="submit" />
      </div>
    </div>
    <mu-dialog :open="deleteDialog" title="删除单位" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="deleteDialog = false">
      确定删除这个单位吗？
      <mu-flat-button slot="actions" @click="deleteDialog = false" primary label="否" />
      <mu-flat-button slot="actions" primary label="确定" @click="deleteHead" />
    </mu-dialog>
    <mu-dialog :open="editDialog" bodyClass="dialogBody input-dialog" actionsContainerClass="dialogActionsContainer" @close="editDialog = false">
      <div class="write-company">
        <p>单位发票抬头</p>
        <input type="text" placeholder="请输入发票抬头" v-model="selCompany.invoiceHead">
        <p>纳税人识别号</p>
        <input type="text" placeholder="请输入纳税人识别号" v-model="selCompany.uniformCode">
      </div>
      <mu-flat-button slot="actions" @click="editDialog = false" primary label="否" />
      <mu-flat-button slot="actions" primary label="确定" @click="saveEdit" />
    </mu-dialog>
    <mu-toast v-if="toast.toast" :message="toast.messageTip" class="custom-toast" />
  </div>
</template>
<script type="text/javascript">
import { mapActions } from 'vuex';
import { storage } from "@common/utils/util.js";
export default {
  data() {
    return {
      load:true,
      seltype: null, //选中的发票类型
      invoiceTitle: '', //发票抬头   个人？单位
      selectedCompanyid: null, //选中的单位
      selCompany: {},
      deleteheadId: null,
      isEditState: false, //编辑状态
      isAddState: false, //新增状态
      deleteDialog: false, //删除弹框
      editDialog: false, //编辑弹框
      addInfo: {}, //用户新增的发票抬头
      invoiceTypeList: [], //获取发票类型列表
      invoiceContentList: [], //获取发票内容列表
      memInvoiceMsgList: [], //获取会员单位发票列表
      // 发票信息
      invoiceData: {
        invoiceType: null, //类型
        invoiceTypeName: null,
        invoiceContent: null, //内容
        invoiceContentName: null,
        invoiceHead: null, //抬头
        uniformCode: null,
      },
      toast:{
          toast:false,
          messageTip:'',
      }

    }
  },
  watch: {

  },
  created() {
    this.getInvoiceType();
    this.getInvoiceContent();
    this.getMemInvoiceMsg();
    if (storage.local.get('invoiceData') != null) {
      this.invoiceData = storage.local.get('invoiceData');
      if (this.invoiceData.uniformCode) {
        this.selectedCompanyid = this.invoiceData.invoiceHead;
        this.invoiceTitle = 'company';
      } else {
        this.invoiceTitle = 'person';
        this.invoiceData.invoiceHead = '个人'
      }
    }
    this.load = false;
  },
  methods: {
    ...mapActions({
      listInvoiceType: 'listInvoiceType', //获取发票类型列表
      listInvoiceContent: 'listInvoiceContent', //获取发票内容列表
      listMemInvoiceMsg: 'listMemInvoiceMsg', //获取会员单位发票列表
      removeMemInvoice: 'removeMemInvoice', //删除会员单位发票
      saveMemInvoice: 'saveMemInvoice', //保存会员单位发票列表
    }),
    //点击单位  选中
    selcompanycheckbox(index) {
      this.invoiceData.invoiceHead = this.memInvoiceMsgList[index].invoiceHead;
      this.invoiceData.uniformCode = this.memInvoiceMsgList[index].uniformCode;
      this.selectedCompanyid = this.memInvoiceMsgList[index].invoiceHead;
    },
    //获取发票类型列表
    getInvoiceType() {
      this.listInvoiceType([]).then(res => {
        this.invoiceTypeList = res;
      })
    },
    //获取发票内容列表
    getInvoiceContent() {
      this.listInvoiceContent([]).then(res => {
        this.invoiceContentList = res;
      })
    },
    //获取会员单位发票列表
    getMemInvoiceMsg() {
      this.listMemInvoiceMsg([]).then(res => {
        this.memInvoiceMsgList = res;
      })
    },
    //编辑
    write(action, index) {
      if (action == 'edit') { //编辑状态  显示编辑删除按钮
        this.isEditState = true;
      } else if (action == 'add') { //添加状态 填写
        this.isAddState = true;
      } else if (action == 'finish') { //完成状态 
        this.isEditState = false;
      } else if (action == 'modify') { //修改状态  修改弹框打开
        this.selCompany = this.memInvoiceMsgList[index];
        this.editDialog = true;
      } else if (action == 'delete') { //删除状态    删除弹框
        this.deleteheadId = this.memInvoiceMsgList[index].invoiceId;
        this.deleteDialog = true;

      } else if (action == 'quit') { //新增   --- 取消
        this.isAddState = false;
      } else if (action == 'save') { //新增   --- 保存
        if (this.addInfo.invoiceHead == null || this.addInfo.uniformCode == null){
          this.toast.messageTip = '请认真填写发票抬头！'
          this.toast.toast = true;
          setTimeout(() => { this.toast.toast = false }, 1500)
          return;
        }
          
        this.saveInvoicehead(0, this.addInfo.invoiceHead, this.addInfo.uniformCode);
        this.isAddState = false;
      }
    },
    //删除发票抬头
    deleteHead() {
      this.removeMemInvoice([this.deleteheadId]).then(res => {
        this.deleteDialog = false;
        this.getMemInvoiceMsg();
        this.toast.messageTip = '删除成功'
        this.toast.toast = true;
        setTimeout(() => { this.toast.toast = false }, 1500)
      }).catch(err =>{
        this.toast.messageTip = '删除失败'
        this.toast.toast = true;
        setTimeout(() => { this.toast.toast = false }, 1500)
      })
    },
    //保存发票抬头
    saveInvoicehead(id, invoiceHead, uniformCode) {
      this.saveMemInvoice([id, invoiceHead, uniformCode]).then(res => {
        this.getMemInvoiceMsg();
        this.addInfo = {}
        this.toast.messageTip = id == 0 ?'新增成功':'修改成功'
        this.toast.toast = true;
        setTimeout(() => { this.toast.toast = false }, 1500)
      })
    },
    //保存编辑
    saveEdit() {
      this.saveInvoicehead(this.selCompany.invoiceId, this.selCompany.invoiceHead, this.selCompany.uniformCode);
      this.editDialog = false;
    },
    //将选中的信息存储   路由跳转
    submit() {
      console.log(this.invoiceData)
      if(this.invoiceData.invoiceTypeName == null){
        this.toast.messageTip = '请选择发票类型！'
        this.toast.toast = true;
        setTimeout(() => { this.toast.toast = false }, 1500)
        return;
      }else if(this.invoiceData.invoiceContentName == null){
        this.toast.messageTip = '请选择发票内容！'
        this.toast.toast = true;
        setTimeout(() => { this.toast.toast = false }, 1500)
        return;
      }
      storage.local.set("invoiceData", this.invoiceData)
      history.go(-1);
    }
  },
  components: {

  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/views/personal/personal.scss';
.input-dialog {
  .write-company {
    input {
      width: 100%;
      border: 1px solid #ccc;
      padding: 0.2rem;
      margin-top: 0.3rem;
      border-radius: 0.05rem;
    }
    input:first-child {
      margin-top: 0.4rem;
    }
    p {
      color: #000;
      text-align: left;
      margin-top: 0.5rem;
    }
  }
}

.invoice-box:first-child {
  margin-top: 0.125rem;
}

.invoice-box {
  margin-bottom: 0.2rem;
  padding: 0.4rem;
  background: #fff;
  @include font-dpr(14px);
  .title {
    color: #999999;
  }
  .content {
    .radio-box {
      padding-top: 0.35rem;
      .list-radio {
        margin-right: 0.5rem;
      }
    }
    .list-radio {
      height: auto;
      min-width: 0.5rem;
      .mu-radio-label {
        @include font-dpr(14px);
      }
    }
    /*发票类型*/
    .invoice-type-box {
      .demo-chip {
        margin-right: 0.25rem;
        background: #FFF;
        border: 1px solid #CFCFCF;
        margin-top: 0.3rem;
        border-radius: 0.05rem;
        line-height: 0.9rem;
      }
      .primary {
        border: 1px solid #E60012;
      }
    }
    /*发票抬头*/
    .invoice-title-box {
      .write-company {
        input {
          width: 100%;
          border: 1px solid #ccc;
          padding: 0.2rem;
          margin-top: 0.3rem;
          border-radius: 0.05rem;
        }
        input:first-child {
          margin-top: 0.4rem;
        }
      }
      .company-list {
        .company-item {
          border: 1px solid #ccc;
          padding: 0.2rem;
          margin-top: 0.3rem;
          p:first-child {
            width: 70%;
          }
          .edit-company {
            label:first-child {
              margin-right: 0.5rem;
            }
          }
        }
        .company-item:first-child {
          margin-top: 0.4rem;
        }
      }
      .operate {
        margin-top: 0.4rem;
        float: right;
        label:first-child {
          margin-left: 0rem;
        }
        label {
          margin-left: 0.5rem;
        }
      }
    }
    /*发票内容*/
    .invoice-content-box {}
  }
}

</style>



// WEBPACK FOOTER //
// writeinvoice.vue?528002ed